import { Component } from '@angular/core';
import { PolicyHeaderComponent } from '../policy-header/policy-header.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-privacy-policy',
    imports: [PolicyHeaderComponent, CommonModule],
    templateUrl: './privacy-policy.component.html',
    styleUrl: '../policy-page.css'
})
export class PrivacyPolicyComponent {
  isLogin = false;
  ngOnInit() {
    this.isLogin = localStorage.getItem('isLogedIn') === 'true';
  }
}
